// extracted by mini-css-extract-plugin
module.exports = {"p":"text_p__Hjdxb","default":"text_default__7I1BE","end":"text_end__97vpA"};